export { CustomersComponent } from './customers.component';
export { AddCustomerComponent } from './add-customer/add-customer.component';
export { EditCustomerComponent } from './edit-customer/edit-customer.component';
export { CustomerDetailsPanelComponent } from './customer-details-panel/customer-details-panel.component';
